import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AccueilGestionComponent} from './accueil/accueil-gestion.component';
import {VersementComponent} from '../deposit/consultation/versement';

import {Roles} from '../common/services/helper-individu/helper-individu.model';
import {CheckGuardService} from '@Services/guards/check-guard.service';
import {BelEditComponent} from "./eliminations/bel-edit/bel-edit.component";
import {BelViewComponent} from "./eliminations/bel-view/bel-view.component";

const routes: Routes = [
  {
    path: '',
    component: AccueilGestionComponent,
    canActivate: [CheckGuardService],
    data: {
      roles: [Roles.admin, Roles.superviseur, Roles.gestionnaire],
      params: {'icon': 'no_accounts', 'message': 'Vous n\'êtes pas autorisé à accéder à cette page'}
    }
  },
  {path: 'versement/consultation-edit/:id', component: VersementComponent, data: {editMode: true}},
  {path: 'elimination/edition-bordereau/:id', component: BelEditComponent},
  {path: 'elimination/visualisation-bordereau/:id', component: BelViewComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GestionRoutingModule {

}
